function monthName(monthNumber: number) {
  switch (monthNumber) {
    case 0:
      return 'January'
    case 1:
      return 'February'
    case 2:
      return 'March'
    case 3:
      return 'April'
    case 4:
      return 'May'
    case 5:
      return 'June'
    case 6:
      return 'July'
    case 7:
      return 'August'
    case 8:
      return 'September'
    case 9:
      return 'October'
    case 10:
      return 'November'
    case 11:
      return 'December'
  }
}

function makeNumberTwoDigitString(value: number) {
  const x = value.toString()
  return x.length === 1 ? `0${x}` : x
}

export function formatDateAsString(date: Date) {
  const month = monthName(date.getMonth())
  const dateStr = `${date.getDate()} ${month} ${date.getFullYear()}`
  const timeStr = `${makeNumberTwoDigitString(date.getHours())}:${makeNumberTwoDigitString(
    date.getMinutes()
  )}`
  return `${timeStr} on ${dateStr}`
}
